import { FormState } from 'final-form';
import { useLocalStore } from 'mobx-react-lite';

import { CallController } from '@gem/call/CallController/CallController';
import { Call } from '@gem/call/CallStore/Call';
import { RecordingType } from '@gem/call/Model/callModel.types';
import { useTranslation } from '@gem/modules/i18n';

import { IStartRecordingPopupPresenter } from '../StartRecordingPopup.presenter';

export interface INewRecordingFormValues {
  title: string;
  recordingType: RecordingType;
}

interface INewRecordingFormOption {
  label: string;
  value: RecordingType;
}

export interface INewRecordingParams {
  call: Call;
  callController: CallController;
  onSuccess: IStartRecordingPopupPresenter['onSuccess'];
}

interface INewRecordingPresenter {
  isValid: boolean;
  isSubmitting: boolean;
  pristine: boolean;
  initialValues: INewRecordingFormValues;
  recordingOptions: INewRecordingFormOption[];
  checkValid(data: FormState<INewRecordingFormValues>): void;
  onSubmit(values: INewRecordingFormValues): Promise<void>;
}

export const useNewRecordingPresenter = (data: INewRecordingParams): INewRecordingPresenter => {
  const { onSuccess } = data;
  const { t } = useTranslation();

  const presenter = useLocalStore<INewRecordingPresenter>(() => ({
    isValid: false,
    isSubmitting: false,
    pristine: false,

    initialValues: {
      title: '',
      recordingType: RecordingType.AudioVideo,
    },

    get recordingOptions(): INewRecordingFormOption[] {
      return [
        {
          value: RecordingType.AudioVideo,
          label: t('calls_recording_video_and_audio'),
        },
        {
          value: RecordingType.Audio,
          label: t('calls_recording_only_audio'),
        },
      ];
    },

    checkValid(data: FormState<INewRecordingFormValues>): void {
      presenter.pristine = data.pristine;
      presenter.isValid = !data.invalid && !data.validating;
    },

    async onSubmit(values: INewRecordingFormValues): Promise<void> {
      if (presenter.isSubmitting) {
        return;
      }

      // if (!presenter.group?.withMeInAdmins) {
      //   if (
      //     values.recordingType === RecordingType.Audio &&
      //     !presenter.group?.memberCustomPermissions?.supportedMediaTypes?.canSendAudio &&
      //     !data.call.isRoom
      //   ) {
      //     popupsTasks.showToast(t('moderation_content_limit_audio'));
      //     return;
      //   }
      //
      //   if (
      //     values.recordingType === RecordingType.AudioVideo &&
      //     !presenter.group?.memberCustomPermissions?.supportedMediaTypes?.canSendVideo &&
      //     !data.call.isRoom
      //   ) {
      //     popupsTasks.showToast(t('moderation_content_limit_video'));
      //     return;
      //   }
      // }

      presenter.isSubmitting = true;
      await onSuccess({
        recordingType: values.recordingType,
        title: values.title.trim(),
      });

      presenter.isSubmitting = false;
    },
  }));

  return presenter;
};
